export default "__VITE_ASSET__Cw3F8w3E__"